import { connect } from "react-redux";

import Component from "./Component";
import {getErrorDescription, getErrorPayload} from "domain/Game/selectors";
import {setViewed} from "domain/Notifications/actions";

const mapStateToProps = (state) => {
    return {
        errorDesc: getErrorDescription(state),
        unreadNotifications: getErrorPayload(state)?.unread_notifications,
    };
};

const mapDispatchToProps = {
    setNotificationsAsViewed: setViewed,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
